import { PromoRoutesEnum } from 'shared/constants/routes'

export type MenuItemLinkType = 'path' | 'anchor' | 'link'

export type MenuItemType = { id: number; type: MenuItemLinkType; label: string; path: PromoRoutesEnum | string }

export const enum SectionIds {
  marketPlaceStat = 'marketPlaceStat',
  openingSteps = 'openingSteps',
  kindsOfPickPoints = 'kindsOfPickPoints',
  videoSection = 'videoSection',
  faq = 'faq',
  authForm = 'authForm'
}

export const enum PromoPageKeys {
  promoModule = 'promoModule',
  shared = 'promoModule.shared',
  countries = 'shared.countries',
  header = 'promoModule.header',
  hero = 'promoModule.hero',
  openPickPointForm = 'promoModule.openPickPointForm',
  map = 'promoModule.map',
  promoLandingPageGe = 'promoModule.promoLandingPageGe',
  openingSteps = 'promoModule.openingSteps',
  loginPage = 'promoModule.promoLandingPageGe.loginPage',
  appsPage = 'promoModule.appsPage',
  cookiePolicy = 'promoModule.cookiePolicy'
}
